module.exports = __webpack_public_path__ + "website/img/code1.fb478225.svg";